import React from "react";
import { withRouter } from "react-router-dom";
import GenericUpper from "../../components/generic-upper";
import { Container } from "react-grid-system";
import { TaglineP } from "../../styles/stylesTypography";
import { theme } from "../../styles/theme";
import { getFlag } from "../../assets/flags";
import { ufDisplayNames, UNSUPPORTED_STATES, ORGAO_CONTACT_MAP } from "./sharedData";
import * as S from "./styles";

const renderRichText = (text) => {
  if (!text) return text;
  return String(text)
    .split(/(<b>.*?<\/b>)/g)
    .map((part, index) => {
      const match = part.match(/^<b>(.*)<\/b>$/);
      return match ? <strong key={index}>{match[1]}</strong> : part;
    });
};

const ExportarDefesasOrgaoDetails = ({ match }) => {
  const uf = match?.params?.uf;
  const stateInfo = UNSUPPORTED_STATES.find((state) => state.uf === uf);
  const contact = ORGAO_CONTACT_MAP[uf];
  const flagSrc = getFlag(uf, ufDisplayNames[uf]);

  return (
    <>
      <GenericUpper title={`Contato do órgão - ${ufDisplayNames[uf] || uf}`} backLink="/exportar-defesas" />
      <Container style={{ paddingLeft: "32px", paddingRight: "32px" }}>
        <div style={{ maxWidth: '820px', margin: '24px auto 0' }}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "16px" }}>
            {flagSrc ? (
              <S.CardFlag src={flagSrc} alt={`Bandeira - ${ufDisplayNames[uf] || uf}`} />
            ) : (
              <S.CardFlagFallback>{uf}</S.CardFlagFallback>
            )}
            {stateInfo?.sigla && <S.CardOrgao>{stateInfo.sigla}</S.CardOrgao>}
          </div>

          {stateInfo?.desc && <S.CardDescription>{renderRichText(stateInfo.desc)}</S.CardDescription>}

          <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "24px" }}>
            {contact?.telefone && (
              <TaglineP color={theme.colors.gray.Cinza_2}>
                Telefone: {contact.telefone}
              </TaglineP>
            )}
            {contact?.email && (
              <TaglineP color={theme.colors.gray.Cinza_2}>
                E-mail: {contact.email}
              </TaglineP>
            )}
            {!contact?.telefone && !contact?.email && (
              <TaglineP color={theme.colors.gray.Cinza_2}>
                Em breve traremos aqui os dados de contato oficiais deste órgão.
              </TaglineP>
            )}
          </div>
        </div>
      </Container>
    </>
  );
};

export default withRouter(ExportarDefesasOrgaoDetails);
